import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OptionListDataServiceInterface, OptionDataServiceInterface } from '../../../../../../discoverer/dynamic-forms/option-lists/shared-services/data-service';
import { FormsDataServiceInterface } from '../../../../../../discoverer/dynamic-forms/dyn-forms/services/forms-data-service.interface';
import { HasuraOptionListService } from '../../../../../../discoverer/dynamic-forms/option-lists/shared-services/hasura-option-list-service';
import { HasuraOptionService } from '../../../../../../discoverer/dynamic-forms/option-lists/shared-services/hasura-option-service';
import { DynFormComponent } from '@discoverer/dynamic-forms/dyn-forms/dyn-form/dyn-form.component';
import { ApplicantDetailsFromService } from '../../applicant-details/applicant-details-form.service';
import { ApplicantTagsFromService } from './applicant-tags-form.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'applicant-tags-dialog',
    templateUrl: './applicant-tags-dialog.html',
    styleUrls: ['./applicant-tags-dialog.scss'],
    providers: [
        { provide: OptionListDataServiceInterface, useClass: HasuraOptionListService },
        { provide: OptionDataServiceInterface, useClass: HasuraOptionService },
        { provide: FormsDataServiceInterface, useClass: ApplicantTagsFromService }

    ]
})
export class ApplicantTagsDialogComponent {
    @ViewChild('dynForm') dynForm: DynFormComponent;
    public isLoading = false;
    public model = {};
    constructor(
        public dialogRef: MatDialogRef<ApplicantTagsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.model = data;
        console.log(this.data.isEditMode)
    }
    close() {
        this.dialogRef.close();
    }

    onSubmit(event) {
        this.isLoading = false;
        if (event) {
            this.dialogRef.close(event);
        }
        else {
            this.isLoading = false;
        }
    }

    public save() {

        this.isLoading = true;

        if (!this.dynForm.form.valid) {
            this.isLoading = false;
        }


        this.dynForm.submit();
    }


}
